// API Response Types for ICP Edit Search

export const ICPEditSearchResponseActionSchema = {
  attribute_value: 'string',
  attribute_name: 'string', 
  must_have_qualifier: 'boolean',
  temporal_qualifier: 'string',
  matching_macros: 'array', // IMatchingMacros[]
  location_details: 'any',
  keywords: 'array' // { attribute_name: string, attribute_value: string }[]
};

export const SSuggestionActionsSchema = {
  ...ICPEditSearchResponseActionSchema,
  must_have_qualifier: 'boolean?' // optional
};

export const GenAISuggestionsSchema = {
  titles: 'array', // string[]
  actions: 'array' // ISSuggestionActions[]
};

export const ICPEditSearchResponseSchema = {
  search_edit_response: {
    user_query: 'string',
    additions: 'array?', // ICPEditSearchResponseAction[]
    removals: 'array?', // ICPEditSearchResponseAction[]
    suggestions: 'object?' // IGenAISuggestions
  }
};

// Helper functions for working with the API response
export const parseICPEditResponse = (response) => {
  if (!response?.search_edit_response) {
    return null;
  }
  
  const { search_edit_response } = response;
  return {
    userQuery: search_edit_response.user_query || '',
    additions: search_edit_response.additions || [],
    removals: search_edit_response.removals || [],
    suggestions: search_edit_response.suggestions || { titles: [], actions: [] }
  };
};

// Map attribute_name to section_id for requirement linking
export const mapAttributeNameToSectionId = (attributeName, requirements = []) => {
  const requirement = requirements.find(req => 
    req.attribute_name === attributeName || 
    req.section_name?.includes(attributeName) ||
    req.bool_str?.includes(attributeName)
  );
  
  return requirement?.section_id || null;
};